import { render, staticRenderFns } from "./IconWaypointType.vue?vue&type=template&id=30c55056"
import script from "./IconWaypointType.vue?vue&type=script&lang=js"
export * from "./IconWaypointType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports